import { isAbsolutePath } from './utils.url';

// Todo, move to .env
const NO_DEALER_PHOTO_PATH = '/images/Autotrader/LeadGenOC/NoDealerPhoto.jpg';
const NO_DEALER_PHOTO_URL = `${process.env.VEHICLE_IMAGE_BASE_URL}${NO_DEALER_PHOTO_PATH}`;

// Takes an array of dealerInfo objects for batch fixes
export function dataFixDealers(dealers = []) {
  return dealers.map((dealerInfo) => {
    return dataFixDealerInfo(dealerInfo);
  });
}

export function appointmentsToDealers(dealers = [], appointments = []) {
  return dealers.map((dealer) => {
    return { ...dealer, ...appointmentToDealer(dealer, appointments) };
  });
}

// Intersect appointments with dealer
export function appointmentToDealer(
  dealer,
  appointments: { dealerId: string; acceptAppointmentRequests: boolean; isRequestedAppointment: boolean; isOfferSentToDealer: boolean }[]
) {
  const appointment = appointments?.find((a) => a.dealerId === dealer.dealerId);

  return { ...dealer, ...appointment, appointmentDay: '', appointmentTime: '', schedule: [] };
}

// Data fix callouts from API
// Fix absolute paths in photo urls
export function dataFixDealerInfo(dealerInfo) {
  return { ...dealerInfo, dealerPhotoUrl: dataFixDealerPhoto(dealerInfo) };
}

export function dataFixDealerPhoto(dealerInfo) {
  if (dealerInfo.hasOwnProperty('dealerPhotoUrl') && !isAbsolutePath(dealerInfo.dealerPhotoUrl)) {
    return dealerInfo.dealerPhotoUrl;
  }
  return NO_DEALER_PHOTO_URL;
}

export function getDealerName(allocatedWithApptData, dealerId) {
  const dealerIndex = findDealerIndex(allocatedWithApptData, dealerId.toString());

  if (!allocatedWithApptData[dealerIndex] || !allocatedWithApptData[dealerIndex].dealerInfo) {
    return;
  }

  return allocatedWithApptData[dealerIndex].dealerInfo.dealershipName;
}

export function findDealerIndex(coll, dealerId) {
  return coll.findIndex((dlr) => (dlr.dealerId || dlr.dealerInfo.dealerId) === dealerId);
}

export function mapDealerInfoToMarker(dealerInfo) {
  if (!dealerInfo) {
    return null;
  }
  const { latitude, longitude, dealershipName, dealershipAddress, dealershipCity, dealershipState, dealershipZipCode, distance, specChosen } = dealerInfo;
  return {
    latitude,
    longitude,
    dealerName: dealershipName,
    dealerAddress: dealershipAddress,
    dealershipCity,
    dealershipState,
    dealershipZipCode,
    distance,
    specChosen,
  };
}
